__turbopack_context__.v({
  "aqua": "StylePanel-module-scss-module__hWhCCa__aqua",
  "blue": "StylePanel-module-scss-module__hWhCCa__blue",
  "cyan": "StylePanel-module-scss-module__hWhCCa__cyan",
  "emerald": "StylePanel-module-scss-module__hWhCCa__emerald",
  "gray": "StylePanel-module-scss-module__hWhCCa__gray",
  "green": "StylePanel-module-scss-module__hWhCCa__green",
  "indigo": "StylePanel-module-scss-module__hWhCCa__indigo",
  "magenta": "StylePanel-module-scss-module__hWhCCa__magenta",
  "moss": "StylePanel-module-scss-module__hWhCCa__moss",
  "neutral": "StylePanel-module-scss-module__hWhCCa__neutral",
  "orange": "StylePanel-module-scss-module__hWhCCa__orange",
  "pink": "StylePanel-module-scss-module__hWhCCa__pink",
  "red": "StylePanel-module-scss-module__hWhCCa__red",
  "sand": "StylePanel-module-scss-module__hWhCCa__sand",
  "select": "StylePanel-module-scss-module__hWhCCa__select",
  "selected": "StylePanel-module-scss-module__hWhCCa__selected",
  "slate": "StylePanel-module-scss-module__hWhCCa__slate",
  "swatch": "StylePanel-module-scss-module__hWhCCa__swatch",
  "violet": "StylePanel-module-scss-module__hWhCCa__violet",
  "yellow": "StylePanel-module-scss-module__hWhCCa__yellow",
});
